import { canUseDOM } from "exenv";
import warning from "tiny-warning";

let globalElement: HTMLElement | null = null;
let globalSelector: string | null = null;

export function assertNodeList(nodeList: { length: number }, selector: string) {
    if (!nodeList || !nodeList.length) {
        throw new Error(`mobius: No elements were found for selector ${selector}.`);
    }
}

function resolveElement() {
    if (globalElement || !globalSelector || !canUseDOM) {
        return globalElement;
    }

    globalElement = document.querySelector<HTMLElement>(globalSelector);
    return globalElement;
}

export function setElement(element: string) {
    globalSelector = element;
    globalElement = null;
    return resolveElement();
}

export function validateElement(appElement: HTMLElement) {
    if (!appElement && !resolveElement()) {
        warning(
            false,
            [
                `mobius: Overlay app element was not found${globalSelector ? ` for selector ${globalSelector}` : ""}.`,
                "Please use `Overlay.setAppElement(el)` or set `appElement={el}`.",
                "This is needed so screen readers don't see main content",
                "when modal is opened.",
            ].join(" "),
        );

        return false;
    }

    return true;
}

export function hide(appElement: HTMLElement) {
    if (validateElement(appElement)) {
        (appElement || globalElement).setAttribute("aria-hidden", "true");
        document.querySelector("body")?.setAttribute("style", "overflow: hidden;");
    }
}

export function show(appElement: HTMLElement) {
    if (validateElement(appElement)) {
        (appElement || globalElement).removeAttribute("aria-hidden");
        document.querySelector("body")?.removeAttribute("style");
    }
}
